import Toast from '@/components/toast';
import React, { useState } from 'react';

interface ToastMessage {
  id?: number;
  message: string;
  type?: 'success' | 'info' | 'warning' | 'error';
}

interface INotificationContext {
  toast: (message: ToastMessage) => void;
}

const NotificationContext = React.createContext<INotificationContext>({} as any);

const NotificationContextProvider = ({ children }: any) => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  const toast = (message: ToastMessage) => {
    setMessages((arr) => [...arr, { ...message, id: new Date().getTime() }]);
  };

  const removeMessage = (id: number) => {
    setMessages((arr) => arr.filter((m) => m.id !== id));
  };

  const notificationContext = {
    toast,
  };

  return (
    <NotificationContext.Provider value={notificationContext}>
      {children}
      {messages.map((m, idx) => (
        <Toast key={idx} open={true} message={m.message} type={m.type} onClose={() => removeMessage(m.id as number)} />
      ))}
    </NotificationContext.Provider>
  );
};

function useNotificationContext() {
  const context = React.useContext(NotificationContext);
  return context;
}

export { NotificationContextProvider, useNotificationContext };
